"use strict";
import emojiRegex from "emoji-regex";
export const emojiInString = (text) => {
  const regex = emojiRegex();
  return text.match(regex);
};
